import React from 'react'
import InsertaScript from '../../utilities/InsertaScript'

const FormSearchHotels = () => {
  const liga =
    '//www.travelpayouts.com/widgets/3705d0d977ed8d8ffffb1fdb02e0cdf7.js?v=2190'
  return <InsertaScript id="form-search-hotels" src={liga} />
}

export default FormSearchHotels
